import React, { useEffect } from "react";
import { isMobile } from 'react-device-detect';

const SliderPlugin = (props) => {
  	useEffect(() => {
		sliderController();

		function sliderController() {
			let active = false;

			let scrollerBottom = document.querySelector(".scroller-bottom")
			let scrollerMiddle = document.querySelector(".scroller-middle")
			let scrollerTop = document.querySelector(".scroller-top")
			let scrollerUltimate = document.querySelector(".scroller-ultimate")

			scrollerUltimate.addEventListener("mousedown", function () {
				active = "ultimate"
				scrollerUltimate.classList.add("scrolling")
			})

			document.body.addEventListener("mouseup", function () {
				active = false
				scrollerUltimate.classList.remove("scrolling")
			})
			document.body.addEventListener("mouseleave", function () {
				active = false
				scrollerUltimate.classList.remove("scrolling")
			})

			scrollerBottom.addEventListener("mousedown", function () {
				active = "bottom"
				scrollerBottom.classList.add("scrolling")
			})
			
			document.body.addEventListener("mouseup", function () {
				active = false
				scrollerBottom.classList.remove("scrolling")
			})

			document.body.addEventListener("mouseleave", function () {
				active = false
				scrollerBottom.classList.remove("scrolling")
			})

			scrollerMiddle.addEventListener("mousedown", function () {
				active = "middle"
				scrollerMiddle.classList.add("scrolling")
			})

			document.body.addEventListener("mouseup", function () {
				active = false
				scrollerMiddle.classList.remove("scrolling")
			})
			document.body.addEventListener("mouseleave", function () {
				active = false
				scrollerMiddle.classList.remove("scrolling")
			})

			scrollerTop.addEventListener("mousedown", function () {
				active = "top"
				scrollerTop.classList.add("scrolling")
			})

			document.body.addEventListener("mouseup", function () {
				active = false
				scrollerTop.classList.remove("scrolling")
			})

			document.body.addEventListener("mouseleave", function () {
				active = false
				scrollerTop.classList.remove("scrolling")
			})

			document.body.addEventListener("mousemove", function (e) {
				if (!active) return;
				let x = e.pageX;
				x -= document.querySelector(".wrapper").getBoundingClientRect().left;
				scrollIt(x);
			})

			// Let's use this function
			function scrollIt(x) {

				let transform = Math.max( 0, Math.min(x, document.querySelector(".wrapper").offsetWidth) );

				if (active === "ultimate") {
					document.querySelector(".ultimate").style.width = transform + "px";
					scrollerUltimate.style.left = transform - 10 + "px";
					if ( scrollerUltimate.getBoundingClientRect().right < scrollerBottom.getBoundingClientRect().right ) {
						document.querySelector(".bottom").style.width = transform + "px";
						scrollerBottom.style.left = transform - 10 + "px";
					}

					if ( scrollerUltimate.getBoundingClientRect().right < scrollerMiddle.getBoundingClientRect().right ) {
						document.querySelector(".middle").style.width = transform + "px";
						scrollerMiddle.style.left = transform - 10 + "px";
					}

					if ( scrollerUltimate.getBoundingClientRect().right < scrollerTop.getBoundingClientRect().right ) {
						document.querySelector(".top").style.width = transform + "px";
						scrollerTop.style.left = transform - 10 + "px";
					}
				}

				if (active === "bottom") {
					document.querySelector(".bottom").style.width = transform + "px";
					scrollerBottom.style.left = transform - 10 + "px";

					if ( scrollerBottom.getBoundingClientRect().right < scrollerMiddle.getBoundingClientRect().right ) {
						document.querySelector(".middle").style.width = transform + "px";
						scrollerMiddle.style.left = transform - 10 + "px";
					}

					if ( scrollerBottom.getBoundingClientRect().right < scrollerTop.getBoundingClientRect().right ) {
						document.querySelector(".top").style.width = transform + "px";
						scrollerTop.style.left = transform - 10 + "px";
					}
				}

				if (active === "middle") {
					document.querySelector(".middle").style.width = transform + "px";
					scrollerMiddle.style.left = transform - 10 + "px";
					if ( scrollerTop.getBoundingClientRect().left > scrollerMiddle.getBoundingClientRect().left ) {
						document.querySelector(".top").style.width = transform + "px";
						scrollerTop.style.left = transform - 10 + "px";
					}
					if ( scrollerBottom.getBoundingClientRect().right < scrollerMiddle.getBoundingClientRect().right ) {
						document.querySelector(".bottom").style.width = transform + "px";
						scrollerBottom.style.left = transform - 10 + "px";
					}
				}

				if (active === "top") {
					document.querySelector(".top").style.width = transform + "px";
					scrollerTop.style.left = transform - 10 + "px";
					if (scrollerTop.getBoundingClientRect().left > scrollerMiddle.getBoundingClientRect().left ) {
						document.querySelector(".middle").style.width = transform + "px";
						scrollerMiddle.style.left = transform - 10 + "px";
					}

					if (scrollerTop.getBoundingClientRect().right > scrollerBottom.getBoundingClientRect().right ) {
						document.querySelector(".bottom").style.width = transform + "px";
						scrollerBottom.style.left = transform - 10 + "px";
					}
				}
			}

			active = "ultimate";
			scrollIt(480);
			active = "bottom";
			scrollIt(400);
			active = "middle";
			scrollIt(320);
			active = "top";
			scrollIt(240);
			active = false;

			if(isMobile){
				active = "ultimate";
				scrollIt(250);
				active = "bottom";
				scrollIt(200);
				active = "middle";
				scrollIt(135);
				active = "top";
				scrollIt(90);
				active = false;
			}

			scrollerUltimate.addEventListener("touchstart", function () {
				active = "ultimate";
				scrollerUltimate.classList.add("scrolling");
			});
			document.body.addEventListener("touchend", function () {
				active = false;
				scrollerUltimate.classList.remove("scrolling");
			});
			document.body.addEventListener("touchcancel", function () {
				active = false;
				scrollerUltimate.classList.remove("scrolling");
			});

			scrollerBottom.addEventListener("touchstart", function () {
				active = "bottom";
				scrollerMiddle.classList.add("scrolling");
			});
			document.body.addEventListener("touchend", function () {
				active = false;
				scrollerBottom.classList.remove("scrolling");
			});
			document.body.addEventListener("touchcancel", function () {
				active = false;
				scrollerBottom.classList.remove("scrolling");
			});

			// second our middle scroller...
			scrollerMiddle.addEventListener("touchstart", function () {
				active = "middle";
				scrollerMiddle.classList.add("scrolling");
			});
			document.body.addEventListener("touchend", function () {
				active = false;
				scrollerMiddle.classList.remove("scrolling");
			});
			document.body.addEventListener("touchcancel", function () {
				active = false;
				scrollerMiddle.classList.remove("scrolling");
			});

			scrollerTop.addEventListener("touchstart", function () {
				active = "top";
				scrollerTop.classList.add("scrolling");
			});
			document.body.addEventListener("touchend", function () {
				active = false;
				scrollerTop.classList.remove("scrolling");
			});
			document.body.addEventListener("touchcancel", function () {
				active = false;
				scrollerTop.classList.remove("scrolling");
			});

			document.querySelector(".wrapper")
				.addEventListener("touchmove", function (e) {
					if (!active) return;
					e.preventDefault();
					let x = e.touches[0].pageX;
					x -= document.querySelector(".wrapper").getBoundingClientRect().left;
					scrollIt(x);
				});
		}
  	}, []);

	return (
		<div className="wrapper">
			<div className="bottomOne">
				<img src={"/assets/food/pizza/pizza4.jpg"} draggable="false" alt="" />
			</div>
			<div className="ultimate">
				<img src={"/assets/food/pizza/pizza2.jpg"} draggable="false" alt="" />
			</div>
			<div className="scroller rounded scroller-ultimate">
				<span className="slide-text-image-slider text-white">SLIDE</span>
			</div>
			<div className="bottom">
				<img src={"/assets/food/pizza/pizza3.jpg"} draggable="false" alt="" />
			</div>
			<div className="scroller rounded scroller-bottom">
				<span className="slide-text-image-slider text-white">SLIDE</span>
			</div>
			<div className="middle">
				<img src={"/assets/food/pizza/pizza5.jpg"} draggable="false" alt="" />
			</div>
			<div className="scroller rounded scroller-middle">
				<span className="slide-text-image-slider text-white">SLIDE</span>
			</div>
			<div className="top">
				<img src={"/assets/food/pizza/pizza1.jpg"} draggable="false" alt="" />
			</div>
			<div className="scroller rounded scroller-top">
				<span className="slide-text-image-slider text-white">SLIDE</span>
			</div>
		</div>
	);
};

export default SliderPlugin;
